import { useCallback, useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Popup } from "components/UI/Popup";
import { IAppState } from "store/app-state";
import { useSelector } from "react-redux";
import { BaseButton } from "components/buttons/BaseButton";
import { routes } from "routes";
import { loadMigrateImgurPopup, setMigrateImgurPopup } from "utils/storage";
import "./MigrateImgurPopup.scss";

export const MigrateImgurPopup = () => {
  const [showPopup, setShowPopup] = useState(false);
  const currentUser = useSelector((state: IAppState) => state.user.currentUser);
  const navigate = useNavigate();

  const shouldShowPopup = useMemo(
    () => currentUser && Object.values(currentUser).length && currentUser.verified && !loadMigrateImgurPopup(),
    [currentUser]
  );

  useEffect(() => {
    if (shouldShowPopup) {
      setShowPopup(true);
    }
  }, [shouldShowPopup]);

  const handleMigrate = useCallback(() => {
    setMigrateImgurPopup(true);
    setShowPopup(false);
    navigate(routes.migrateImgur());
  }, [navigate]);

  const handleDismiss = useCallback(() => {
    setMigrateImgurPopup(true);
    setShowPopup(false);
  }, []);

  return (
    <Popup
      title="Got content with Imgur?"
      isOpen={showPopup}
      popupClass="MigrateImgurPopup"
    >
      <div className="MigrateImgurPopup-Cnt">
        <p>If you have any content hosted on Imgur, would like us to transfer it over for you?</p>
        <BaseButton onClick={handleMigrate}>Yes, show me how!</BaseButton>
        <button className="MigrateImgurPopup-CancelBtn" onClick={handleDismiss}>No, thanks</button>
      </div>
    </Popup>
  );
};
